/* eslint-disable no-use-before-define */
import React from 'react'
import { getId, Loading, show as gotoTab, getEventHandlers, showModal, isCusip } from '../../../twd'
import { useCusipSearch } from './use-cusip-search'

export const CusipSearch = ({acctNo, cusip,  setCusip, readOnly=false, errors={}, isQrt=false} = {}) => {

    const elId = getId()
    const [show, setShow] = React.useState(false)
    const [inputEl, setInputEl] = React.useState(null)
    const [resultEl, setResultEl] = React.useState(null)
    const [keyword, setKeyword] = React.useState(cusip)

    React.useEffect(() => {
        setKeyword(cusip)
    }, [cusip])

    const { status, error, searchResults } = useCusipSearch({keyword, isQrt})
    const symbols = React.useMemo(() => getSearchResultSymbols(searchResults), [searchResults])
    const issuers = React.useMemo(() => getSearchResultIssuers(searchResults), [searchResults])
    const cusips = React.useMemo(() => getSearchResultCusips(searchResults, keyword), [searchResults])

    const onSearch = ({label, searchParams}) => {
        showModal({
            view: 'order-ticket-search-modal',
            title: label,
            searchParams,
            from: 'order-ticket',
            source: inputEl,
            acctNo,
        })
    }

    const id = getId()
    const err = errors && errors.cusip

    return <React.Fragment>
        <div className="from-group"
            style={{paddingLeft:'0px', paddingRight:'0px'}}
        >
            <label htmlFor={id} className="label">{isQrt ? "CUSIP" : "CUSIP, symbol or company name"}</label>
            <div className={err ? ' has-error' : ''}>
            <input
                ref={setInputEl}
                type="text"
                id={id}

                className='form-control'
                {...(show && {"aria-controls": elId }) }
                aria-autocomplete='list'
                aria-haspopup='listbox'
                aria-expanded={show}
                role='combobox'
                autoComplete='off'
                readOnly={readOnly}
                aria-readonly={readOnly}
                value={keyword}

                onChange={(e) => {
                    const val = e.target.value || ''
                    setKeyword(val)
                    if (!isQrt) { setShow(!!val) }
                }}

                onPaste={(e) => {
                    let v  = e.clipboardData.getData('text/plain')
                    if (!v) return
                    v = v.toUpperCase().trim()

                    if (!isCusip(v)) return
                    e.preventDefault()
                    setCusip(v)
                }}

                onBlur={(e) => {
                    if (!show && !isQrt) return
                    if (resultEl && resultEl.getAttribute('mouse-on-result')) {
                        inputEl.focus()
                        return
                    }
                    setShow(false)

                    let v = e.target.value || ''
                    if (!v) return
                    v = v.toUpperCase().trim()

                    if (!isCusip(v)) return
                    setCusip(v)
                }}

                onKeyUp={(e) => {
                    let key = e.keyCode || e.key || e.which
                    if (!(key===13 || key === 'Enter')) return

                    let v = e.target.value
                    if (!v) return
                    v = v.toUpperCase().trim()

                    if (isCusip(v)) {
                        e.preventDefault()
                        e.target.blur()
                        return
                    }

                    if (!resultEl) { return }

                    let el = resultEl.querySelector('.auto-suggest-menu-item')
                    if (!el) return

                    let i = getEventHandlers(el).item
                    if (!i) return

                    e.preventDefault()
                    e.target.blur()
                    onSearch(i)
                }}

                onKeyDown={(e) => {
                    let key = e.keyCode || e.key || e.which

                    const isEsc = key === 27 || key==='Escape'
                    const isTab = key===9 || key==='Tab'

                    if (isTab) {
                        if (show) resultEl.removeAttribute('mouse-on-result')
                        setKeyword(cusip || '')
                        inputEl.blur()
                        return
                    }

                    if (isEsc) {
                        inputEl.value = ''
                        setKeyword('')
                        return
                    }

                    if (!show) return

                    if (key === 38 || key==='ArrowUp') {
                        moveSearchResultItemFocus(resultEl, -1)
                        return
                    }

                    if (key === 40 || key==='ArrowDown') {
                        moveSearchResultItemFocus(resultEl, 1)
                        return
                    }
                }}
            />
            { err && <label className="field-status has-error">{err}</label> }
            </div>

        {show && <div
            ref={setResultEl}
            className="auto-suggest-menu"
            id={elId}
            role="listbox"
            style={{margin:'6px 12px', padding:'6px 12px', top:'auto'}}
            onMouseOver={()=> {
                resultEl.setAttribute('mouse-on-result', 'Y')
            }}
            onMouseOut={() => {
                resultEl.removeAttribute('mouse-on-result')
            }}
        >
        <Loading status={status} error={error} spinner={false}>
            { !isQrt && symbols.map( (a, i) => formatSearchResultItem('Symbol(s)', a, i, onSearch) ) }
            { !isQrt && issuers.map( (a, i) => formatSearchResultItem('Issuer(s)', a, i, onSearch) ) }
            { cusips.map( (a, i) => formatSearchResultItem('CUSIP(s)', a, i, onSearch) ) }
        </Loading>
        </div>}

        </div>

        {!isQrt && <div>
            <a href="#" onClick={() => {
                gotoTab('advanced-screener', Object.assign({
                    _ts: Date.now(),
                    from:'order-ticket'
                }))
            }}>
                <i className="material-icons" aria-hidden="true" style={{color:'var(--primary-base-color)'}}>search</i>
                Advanced lookup</a>
        </div>}
    </React.Fragment>
}

const formatSearchResultItem = (title, item, i, onSearch) => {
    const id = getId()
    if (i===0) {
        return <div key={`${title}-${i}`} aria-labelledby={id} role='group'>
            <div className="auto-suggest-menu-header"
                id={id}
                role="presentation"
            >{title}</div>
            {formatItem(item, i, onSearch)}
            </div>
    }
    return formatItem(item, i, onSearch)
}

const formatItem = (item, i, onSearch) => {
    return <div
        key={`cusip-search-${i}`}
        aria-selected='false'
        className='auto-suggest-menu-item text-truncate'
        style={{ color:"var(--primary-base-color)" }}
        role="option"
        item={item}
        onClick={() => onSearch(item)}
    >
        {item.label}
    </div>
}

const moveSearchResultItemFocus = (resultEl, k) => {
    let arr = Array.from(resultEl.querySelectorAll('.auto-suggest-menu-item'))
    let n = arr.length
    if (n===0) return

    let i = arr.findIndex((e) => e.classList.contains('focus'))
    if (i>=0) {
        arr[i].classList.remove('focus')
        arr[i].setAttribute('aria-selected', 'false')
    }

    i = (n + i + k) % n
    arr[i].classList.add('focus')
    arr[i].setAttribute('aria-selected', 'true')
}


export const getSearchResultSymbols = (rs) => Object.values(rs.reduce((x,r) => {
    let t = r.type
    if (t!=='C') return x

    let k = r.symbol
    if (!k || k in x) return x

    x[k] = {
        type: 'symbol',
        label:k,
        value:r.cusip,
        searchParams:{
            holdInvType:['C'],
            holdSymbol:[k]
        }
    }
    return x
}, {}))

export const getSearchResultIssuers = (rs) =>  Object.values(rs.reduce((x,r) => {
    let k = r.issue
    if (!k || k in x) return x

    x[k] = {
        type: 'issuer',
        label:k,
        value:r.cusip,
        searchParams:{
            holdIssue:[k]
        }
    }
    return x
}, {}))

export const getSearchResultCusips = (rs, keyword) => Object.values(rs.reduce((x,r) => {
    let k = r.cusip
    if (!k || k in x) return x

    x[k] = {
        type: 'cusip',
        label:k,
        value:k,
        searchParams:{
            holdCusip:[k],
            holdIdentifierLabel: "holdCusip",
            holdIdentifiers:[k]
        }
    }
    return x
}, {}))



// WEBPACK FOOTER //
// ./src/order-ticket/form/cusip-search/cusip-search.js